import React from 'react'
import { RejectionInfo } from '../../teamExperiences/models/ExperienceSummaryModel'
import { formatDateShortIntl2 } from '../../../helpers/FormatDate'

type Props = {
  items?: RejectionInfo[]
}

export const InfoHistory: React.FC<Props> = ({ items = [] }) => {
  const validItems = (items ?? []).filter((item) => Boolean(item && (item.reason || item.note)))

  if (validItems.length === 0) {
    return null
  }

  return (
    <div className="info-history">
      <div className="info-history__header">
        <span className="info-history__label">Info</span>
      </div>

      {validItems.map((item, index) => (
        <InfoHistoryItem
          key={item.id ?? index}
          reason={item.reason}
          note={item.note}
          createdAt={formatDateShortIntl2(item.createdAt)}
          rejectedBy={item.rejectedBy}
        />
      ))}
    </div>
  )
}

export const InfoHistoryItem: React.FC<RejectionInfo> = ({ reason, note, createdAt }) => {
  return (
    <div className="info-history__item">
      {reason && (
        <div className="info-history__item-title">
          {createdAt} - {reason}
        </div>
      )}
      {note && (
        <div className="info-history__item-description">
          {note}
        </div>
      )}
    </div>
  )
}

